export const VALHEIM_MOD_SELECTOR = '[data-name="valheim-mods"]';

export class ValheimCustomSettingsUI {
  public constructor(private $base: JQuery) {
  }

  public render() {
    return new Promise((resolve) => {
      resolve();
    });
  }

  public getValheimModsValue(): string {
    return this.$base.find(VALHEIM_MOD_SELECTOR).val().toString();
  }

  public onModChange(callback: (value: string, target: JQuery) => void) {
    this.$base.find(VALHEIM_MOD_SELECTOR).on('change', (e: JQuery.TriggeredEvent) => {
      const val = e.currentTarget.value;
      callback(val, e.currentTarget);
    });
  }

  public handleValheimModChange(value: string) {
    const valheimPlusSettingsShouldBeShown = value === 'valheimPlus';
    const settingsElementsDisplayValue = valheimPlusSettingsShouldBeShown ? '': 'none';
    // get one setting out of the section, get its parent, hide the parent.
    // then, get the previous sibling, which is the title of the section and hide as well
    // Valheim-Plus-Display is in valheimPlus settings section
    const valheimPlusSettingsElement = document.querySelector('[data-search-value="Valheim-Plus-Display"]').parentElement;
    // show/hide the element with settings
    valheimPlusSettingsElement.style.display = settingsElementsDisplayValue;
    // hide the title of the section
    const valheimPlusTitleElement = valheimPlusSettingsElement.previousElementSibling as HTMLElement;
    valheimPlusTitleElement.style.display = settingsElementsDisplayValue;
  }
}
